import { Car, InspectionReason, Region, Subdivision } from '~/shared/api'
import { Filter } from '~/shared/ui/AsyncGrid/types'

export const filters: Filter[] = [
  {
    field: 'driverFullName',
    label: 'filter.driver full name',
    type: 'text',
  },
  {
    field: 'responsibleName',
    label: 'filter.mechanic full name',
    type: 'text',
  },
  {
    field: 'carId',
    label: 'filter.plate number',
    type: 'autocomplete',
    fetchOptions: Car.fetchPlateNumberOptions,
  },
  {
    field: 'carVin',
    label: 'filter.vin',
    type: 'text',
  },
  {
    label: 'filter.inspection date',
    type: 'dateRange',
    startField: 'finishedAtDateGte',
    endField: 'finishedAtDateLte',
  },
  {
    field: 'reasonId',
    label: 'filter.inspection reason',
    type: 'autocomplete',
    fetchOptions: InspectionReason.fetchOptions,
  },
  {
    field: 'regionId',
    label: 'filter.region',
    type: 'autocomplete',
    fetchOptions: Region.fetchOptions,
  },
  {
    field: 'subdivisionId',
    label: 'filter.subdivision',
    type: 'autocomplete',
    fetchOptions: Subdivision.fetchOptions,
  },
  {
    field: 'comment',
    label: 'filter.comment',
    type: 'text',
  },
  {
    field: 'hasDamages',
    label: 'filter.has damages',
    type: 'boolean',
  },
  {
    field: 'hasDocumentsLoss',
    label: 'filter.has documents loss',
    type: 'boolean',
  },
]
